export default "__VITE_ASSET__6QsEMOgY__"